namespace TabAurous.Common {
    export enum SalaryType {
        Monthly = 1,
        Daily = 2
    }
    Serenity.Decorators.registerEnumType(SalaryType, 'TabAurous.Common.SalaryType', 'HR.SalaryType');
}
